let accordionsButtons = document.querySelectorAll(".js-accordion__button");

if(accordionsButtons){
    for (let index = 0; index < accordionsButtons.length; index++) {
        accordionsButtons[index].addEventListener("click", function () {
            this.classList.toggle("accordion__button-active");
            let accordionsContent = this.nextElementSibling;
        
            if(accordionsContent){
                if (accordionsContent.style.maxHeight) {
                    accordionsContent.style.maxHeight = null;
                    accordionsContent.classList.remove("accordion__content-active");
                } else {
                    
                    document.querySelectorAll('.accordion__content').forEach((content) => {
                        content.classList.remove("accordion__content-active");
                        content.style.maxHeight = null;
                    });
                    accordionsButtons.forEach((button) => {
                        button.classList.remove("accordion__button-active");
                    });
                    accordionsButtons[index].classList.add("accordion__button-active");
                    accordionsContent.classList.add("accordion__content-active");
                    accordionsContent.style.maxHeight = accordionsContent.scrollHeight + "px";
                }
            }
        });
    }
}